import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import closest from 'closest';

import { routes } from 'config/routes';
import { getIsWhitelisted, getIsAuthenticated } from 'selectors/auth';
import { getUser } from 'selectors/user';

const SIDE_NAV_AUTH_MENU = 'side-nav-auth-menu';

export class SideGlobalNavigation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      toggleAuthMenuVisible: true,
    };

    this.onClickAuthMenuToggle = this.onClickAuthMenuToggle.bind(this);
    this.onWindowClick = this.onWindowClick.bind(this);
  }

  componentDidMount() {
    window.addEventListener('click', this.onWindowClick);
  }

  componentWillUnmount() {
    window.removeEventListener('click', this.onWindowClick);
  }

  onClickAuthMenuToggle(e) {
    e.stopPropagation(); // to prevent window listener from grabbing
    this.setState(state => ({
      toggleAuthMenuVisible: !state.toggleAuthMenuVisible,
    }));
  }

  onWindowClick(e) {
    const authMenuVisible = !this.state.toggleAuthMenuVisible;
    const clickWasInsideAuthMenu = !!closest(e.target, `#${SIDE_NAV_AUTH_MENU}`, true);

    // if the auth menu is visible, and the click was outside it, hide
    // the auth menu
    if (authMenuVisible && !clickWasInsideAuthMenu) {
      this.setState(() => ({
        toggleAuthMenuVisible: true,
      }));
    }
  }

  render() {
    const { isAuthenticated, userInfo, isWhitelisted } = this.props;
    const firstName = (userInfo.displayName || '').split(' ')[0] || userInfo.id;

    return (
      <nav className="side-global-nav">
        <Link title="Spotify Ad Studio homepage" to={routes.BROWSE_ADS} className="navbar-brand">
          <span className="navbar-logo">Spotify Ad Studio</span>
        </Link>
        <Link
          title="Spotify Ad Studio build ad page"
          id="create-ad-link"
          to={routes.BUILD_AD}
          className="create-ad-btn btn btn-azure btn-sm center-block ta-build-ad-button"
        >
          Create Ad
        </Link>
        <ul className="side-nav-top">
          {isAuthenticated &&
            isWhitelisted &&
            <li>
              <Link
                title="Spotify Ad Studio browse ads page"
                id="browse-ads-link"
                activeClassName="active"
                to={routes.BROWSE_ADS}
              >
                My ads
              </Link>
            </li>}
          {isAuthenticated &&
            isWhitelisted &&
            <li>
              <Link
                title="Spotify Ad Studio account settings"
                id="account-settings-link"
                to={routes.ACCOUNT_SETTINGS}
                activeClassName="active"
              >
                My account
              </Link>
            </li>}
          {(!isWhitelisted || !isAuthenticated) &&
            <li>
              <Link title="Spotify Ad Studio get access page" id="get-access-link" to={routes.WAITLIST}>
                Join Waitlist
              </Link>
            </li>}
          {!isAuthenticated &&
            <li>
              <Link title="Spotify Ad Studio log in page" id="navbar-login" to={routes.LOGIN}>
                Log In
              </Link>
            </li>}
        </ul>
        <ul className="side-nav-footer">
          <li>
            <Link title="Spotify Ad Studio FAQ and help page" id="faq-help-link" to={routes.FAQ}>
              FAQ & Help
            </Link>
          </li>
          <li>
            <Link title="Spotify Ad Studio Terms and Conditions page" id="terms-conditions-link" to={routes.BETA_TERMS}>
              Terms and Conditions
            </Link>
          </li>
          <li className="beta-wrapper">
            <svg role="img" className="beta-logo" width="42" height="22" viewBox="0 0 42 22" xmlns="http://www.w3.org/2000/svg">
              <title>Spotify Ad Studio beta</title>
              <desc>This application is currently in beta.</desc>
              <g fillRule="nonzero" fill="none">
                <path d="M39 22H3c-1.657 0-3-1.343-3-3V3c0-1.657 1.343-3 3-3h36c1.657 0 3 1.343 3 3v16c0 1.657-1.343 3-3 3zM3 2c-.552 0-1 .448-1 1v16c0 .552.448 1 1 1h36c.552 0 1-.448 1-1V3c0-.552-.448-1-1-1H3z" fill="#414141"/><path d="M10.91 7.46c.548-.072 1.1.096 1.515.463.415.366.65.894.645 1.447.024.668-.377 1.278-1 1.52.76.197 1.28.896 1.25 1.68.003.565-.234 1.105-.65 1.486-.42.38-.977.568-1.54.514H8.36V7.46h2.55zm-.21 2.93c.254.032.51-.048.702-.218.19-.17.3-.416.298-.672 0-.54-.35-.88-1-.88h-1v1.77h1zm.14 3c.67 0 1.07-.35 1.07-.92.01-.264-.094-.52-.286-.7-.19-.182-.45-.273-.714-.25H9.72v1.87h1.12zM15.06 14.54V7.46h4.44v1.3h-3.06v1.62h2.77v1.22h-2.77v1.64h3.06v1.3M24.31 8.77v5.78h-1.39V8.77h-2.24V7.46h5.87v1.31M31.55 12.92h-2.88l-.59 1.62h-1.46l2.72-7.09h1.6l2.7 7.09h-1.5l-.59-1.62zm-2.42-1.26h2L30.11 9l-.98 2.66z" fill="#A2A5A7"/>
              </g>
            </svg>
          </li>
          {isAuthenticated &&
            <li className="user-profile">
              <a
                title="Spotify Ad Studio user profile"
                id="user-profile"
                className="user-profile-btn"
                role="button"
                aria-controls={SIDE_NAV_AUTH_MENU}
                href="#"
                onClick={this.onClickAuthMenuToggle}
                title={firstName}
                tabIndex="0"
              >
                {userInfo.imgSrc &&
                  <img alt="user-profile" className="user-img img-circle navbar-user-img" src={userInfo.imgSrc} />}
                {firstName}
                <span className={classnames('dropdown-arrow', {
                  'dropdown-arrow-active': !this.state.toggleAuthMenuVisible,
                })}>
                  <svg width="24" height="23" viewBox="0 0 24 23" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M12.023 13.688L8.12 9.174l-.753.653 4.656 5.44 4.67-5.44-.752-.653-3.917 4.514zm0 8.313c-5.764 0-10.45-4.71-10.45-10.5S6.258 1 12.022 1c5.76 0 10.448 4.71 10.448 10.5S17.785 22 12.023 22zm0-22C5.7 0 .576 5.148.576 11.5.577 17.85 5.7 23 12.022 23c6.32 0 11.445-5.15 11.445-11.5 0-6.352-5.125-11.5-11.445-11.5z"
                      fillRule="evenodd"
                    />
                  </svg>
                </span>
              </a>
            </li>}
          {isAuthenticated &&
            <div
              id={SIDE_NAV_AUTH_MENU}
              role="menu"
              className={classnames('carat-toggle', {
                hide: this.state.toggleAuthMenuVisible,
                show: !this.state.toggleAuthMenuVisible,
              })}
            >
              <Link title="Spotify Ad Studio Log out" id="log-out-link" role="menuitem" to={routes.LOGOUT}>
                Log Out
              </Link>
            </div>}
        </ul>
      </nav>
    );
  }
}

SideGlobalNavigation.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  isWhitelisted: PropTypes.bool.isRequired,
  userInfo: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    isAuthenticated: getIsAuthenticated(state),
    isWhitelisted: getIsWhitelisted(state),
    userInfo: getUser(state),
  };
}

export default connect(mapStateToProps)(SideGlobalNavigation);



// WEBPACK FOOTER //
// ./src/components/SideGlobalNavigation.js